<template>
<card no-body class="card-recipe" v-if="recipeData">
    <div class="card__aside">
        <div class="slider">
            <div class="slider__clip">
                <div class="slider__slides js-slider" v-if="(recipeSlides && recipeSlides.length > 0)">
                    <div class="slider__slide" v-for="slide in recipeSlides" v-bind:key="slide.index">
                        <div class="slider__slide-image" v-bind:style="'background-image: url(' + slide.img + ');'" rel="img"></div>
                    </div>
                </div>

                <div class="slider__slides js-slider" v-else>
                    <div class="slider__slide" v-for="slide in tempSlides" v-bind:key="slide.index">
                        <div class="slider__slide-image" v-bind:style="'background-image: url(' + slide.img + ');'" rel="img"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card__content">
        <div class="card__head">
            <span v-for="item in recipeData.recipeBrands" v-bind:key="item.id">
                <img v-if="item.brand.logo" v-bind:src="item.brand.logo.absoluteUri" :alt="item.brand.name" class="card__logo" />
                <span class="brand-name" v-else>{{ item.brand.name }}</span>
            </span>
            <!--div class="statusName">{{ recipeData.statusName }}</div-->
            <a class="original-file" :href="`http://acxionspringboard.blob.core.windows.net/docs/${recipeData.originalFile}`" target="_blank" v-if=" recipeData.originalFile "><i class="far fa-file-excel"></i></a>
            <badge class="statusName badge-dot" type="inherit">
                <i :class="`bg-${recipeData.statusCode}`"></i>
                <span class="status font-weight-600">{{ recipeData.statusName && recipeData.statusName != null ? recipeData.statusName : 'Created' }}</span>
            </badge>

            <div class="card__head-inner">
                <h1 class="card__title font-weight-600 js-truncate">
                    {{ recipeData.name }}
                </h1>
                
                <div class="jobCodeOperator">
                    <span>{{ recipeData.jobCode }}</span>
                    <span v-if="operatorNames" class="operatorName">{{ operatorNames }}</span>
                </div>
            </div>

            <div class="card__author">
                <div class="card__author-image">
                    <img v-bind:src="
                        recipeData.user && recipeData.user.image
                        ? recipeData.user.image.absoluteUri
                        : '/img/DefaultUser.gif'
              " alt="" />
                </div>

                <div class="card__author-content">
                    <h5>
                        {{ recipeData.user ? recipeData.user.fullNameFirstLast : "WhipStir" }}
                    </h5>
                    <span>{{ recipeData.recipeDate }}</span>
                </div>

                <div class="card__author-actions">
                    <ul class="list-icons card__head-list">
                        <li>
                            <a href="#" v-on:click="handleFavorite(recipeData.id)">
                                <i v-bind:class="[( this.userRecipeData && this.userRecipeData.hasFavorited) ? 'fas' : 'far']" class=" fa-heart"></i>
                            </a>
                        </li>

                        <li>
                            <a href="#">
                                <i class="fa fa-file-pdf" title="Download PDF File" @click="print()"></i>
                            </a>
                        </li>

                        <li>
                            <a href="#">
                                <i class="fa fa-file-powerpoint" title="Download Powerpoint File" @click="printPPT()"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="card__body">
            <div class="card__body-content" :class="hasAsideClass">
                <div class="card__entry js-summary">
                    <p v-html="recipeData.description" class="js-truncate-text"></p>
                </div>

                <!--
                <a href="#" class="btn btn-primary btn-icon card__body-btn"
                        v-if="$store.getters.userIsAdmin && variations && !variations.some(v => v.languageCode === 3)"
                        @click.prevent="cloneRecipe(3)">
                    <i class="fas fa-plus"></i>
                    <span>Add Spanish</span>
                </a>

                <a href="#" class="btn btn-primary btn-icon card__body-btn"
                        v-if="$store.getters.userIsAdmin && variations && !variations.some(v => v.languageCode === 2)"
                        @click.prevent="cloneRecipe(2)">
                    <i class="fas fa-plus"></i>
                    <span>Add French</span>
                </a>
                -->

                <a href="" class="btn btn-primary btn-icon card__body-btn" v-if="this.$store.getters.userIsAdmin" v-on:click.prevent="cloneRecipe(1)">
                    <i class="fas fa-plus"></i>
                    <span>Clone</span>
                </a>

                <a href="#" class="btn btn-primary btn-icon card__body-btn" 
                :class="this.addToCollections? '' : 'disabled'"
                v-on:click="handleAddToCollection()">
                    <i class="fas fa-plus"></i>
                    <span>Add to Collection</span>
                </a>

            </div>

            <div class="card__body-aside" >
                <ul class="list-info">
                    <li v-if="recipeTags.length > 0">
                        <i class="fas fa-tag"></i>

                        <p v-for="tag in recipeTags" v-bind:key="tag.tag.id">
                            <a :href="'/tag/' + tag.tag.id">{{ tag.tag.name }}</a>
                        </p>
                    </li>
                    <li v-if="recipeData.recipeCollections && recipeData.recipeCollections.length > 0">
                        <i class="ni ni-books"></i>
                        <p v-for="item in recipeData.recipeCollections" v-bind:key="item.id">
                            <a :href="'/collection/' + item.collection.id">{{ item.collection.title }}</a>
                        </p>
                    </li>
                </ul>
            </div>
        </div>

        <div>
            <ul>
                <li v-for="variation in filteredVariations" :key="variation.id">
                <a :href="'/recipe/' + variation.id + getLangSuffix(variation.languageCode)">
                    {{ variation.name }}
                </a>
                </li>
            </ul>
        </div>

        <div id="previewWidget">
        </div>
        
        <div class="card__actions">
            
            <div class="icon-actions">
                <a href="#" class="like js-recipe-likes" :class="[( this.userRecipeData && this.userRecipeData.hasLiked) ? 'active' : '']" v-on:click="handleLike($event, recipeData.id)">
                    <i class="ni ni-like-2"></i>
                    <span class="text-muted">{{ likes }}</span>
                </a>
                <a href="#comments">
                    <i class="ni ni-chat-round"></i>
                    <span class="text-muted">{{ commentCount }}</span>
                </a>
                <a href="#" :class="[(this.userRecipeData && this.userRecipeData.hasShared) ? 'active' : '']" v-on:click="handleShare()">
                    <i class="ni ni-curved-next"></i>
                    <span class="text-muted">{{ recipeData.shares }}</span>
                </a>
            </div>

            <div class="card__actions-aside" v-if="(recipeData.recipeContributors && recipeData.recipeContributors.length > 0)">

                <div class="avatar-group">
                    <a 
                    v-bind:key="recipeData.user.id" href="#" 
                    class="avatar avatar-xs rounded-circle" 
                    data-toggle="tooltip" 
                    :data-original-title="recipeData.user.fullNameFirstLast">

                        <img :alt="`Profile image for ${recipeData.user.fullNameFirstLast}`" :src="recipeData.user.image? recipeData.user.image.absoluteUri : '/img/DefaultUser.gif'" />

                    </a>
                    <a 
                    v-for="item in recipeData.recipeContributors" 
                    v-bind:key="item.id" href="#" 
                    class="avatar avatar-xs rounded-circle" 
                    data-toggle="tooltip" 
                    :data-original-title="item.user.fullNameFirstLast">

                        <img :alt="`Profile image for ${item.user.fullNameFirstLast}`" :src="item.user.image? item.user.image.absoluteUri : '/img/DefaultUser.gif'" />

                    </a>
                </div>

            </div>
        </div>
    </div>
</card>
</template>

<script>
import Flickity from "flickity";
import { distanceInWords, addHours } from 'date-fns'
import Settings from "@/whipstir"
import swal from 'sweetalert2'
import { apiClient } from '../../_helpers';
import { authHeader } from '../../_helpers';
import axios from 'axios'

export default {
    name: "recipe-header",
    props: ["recipeData"],
    components: {
        Flickity,
        Settings,
        distanceInWords,
        addHours,
        swal,
        apiClient
    },
    data() {
        return {
            data: null,
            slickOptions: {
                slidesToShow: 1,
            },
            cuisine: [],
            equipmentHtml: "",
            recipeCuisine: "",
            shareUserId: null,
            tempSlides: [{
                img: this.$store.state.settings.current.defaultRecipeMainImage ? this.$store.state.settings.current.defaultRecipeMainImage.absoluteUri : '' + '?width=600'
            }],
            likeId: '',
            userList: {},
            collectionList: {},
            addToCollections: true,
            currentLang: this.getCurrentLang()
        };
    },
    computed: {
        userRecipeData() {
            return this.$store.state.recipes.current.userData
        },
        filteredVariations() {
            const currentLang = this.$route.query.lang || 'en';
            return this.variations.filter(v => this.getLangCode(v.languageCode) !== currentLang);
        },
        hasAsideClass() {
            if ( (!this.recipeData.recipeTags || this.recipeData.recipeTags.length < 1) && (!this.recipeData.recipeCollections || this.recipeData.recipeCollections.length < 1) ) {
                return 'card__full_width'
            }
            return ''
        },
        recipeSlides() {
            const slides = [];
            if(this.$store.state.recipes.current.image.absoluteUri != null){
                slides.push({ img: this.$store.state.recipes.current.image.absoluteUri + '?width=600' });
            }
            const images = this.$store.state.recipes.current.recipeImages
            for (const property in images) {
                slides.push({ img: images[property].image.absoluteUri + '?width=600' });
            }
            if(slides.length == 0){
                if(this.$store.state.settings.current.defaultRecipeMainImage)
                    slides.push({ img: this.$store.state.settings.current.defaultRecipeMainImage.absoluteUri + '?width=600' });
                else
                    slides.push({ img: 'XXX' });      
            }
            return slides;
        },
        allTags() {
            return this.$store.state.recipes.current.recipeTags;
        },
        recipeTags() {
            const tags =[]
            for (const property in this.allTags) {
                if ( !this.allTags[property].tag.isDietary ) {
                    tags.push(this.allTags[property]);
                }
            }
            return tags;
        },
        likes() {
            return this.$store.state.recipes.current.likes;
        },
        userData() {
            return this.$store.state.authentication.user.user;
        },
        commentCount() {
            return Object.keys(this.$store.state.comments.current).length
        },
        isLoading() {
            return this.$store.getters.recipesLoading
        },
        users() {
            return this.$store.state.users.all.results
        },
        collections() {
            return this.$store.state.collections.all.results
        },
        variations() {
            return this.$store.state.recipes.recipeVariations
        },
        lang() {
            return this.$route.query.lang
        },
        operatorNames() {
            if (
            !this.recipeData ||
            !Array.isArray(this.recipeData.recipeOperators) ||
            this.recipeData.recipeOperators.length === 0
            ) {
            return ''
            }

            return this.recipeData.recipeOperators
            .map(o => o && o.operator && o.operator.name)
            .filter(Boolean)
            .join(', ')
        }
    },
    methods: {
        getLangCode(code) {
            const map = {
            1: 'en',
            2: 'fr',
            3: 'es'
            };
            return map[code] || 'en';
        },
        getLangSuffix(code) {
            const lang = this.getLangCode(code);
            return lang === 'en' ? '' : '?lang=' + lang;
        },
        getCurrentLang() {
            const params = new URLSearchParams(window.location.search);
            return params.get('lang') || 'en';
        },
        cloneRecipe(lang) {
            let title;

            if (lang === 3) {
                title = 'Create Spanish Version?';
            } else if (lang === 2) {
                title = 'Create French Version?';
            } else {
                title = 'Clone Recipe?';
            }

            swal.fire({
            title: title,
            type: 'warning',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-danger btn-fill',
            confirmButtonText: 'Clone',
            buttonsStyling: false,
            }).then((result) => {
            if (result.value) {
                const { dispatch } = this.$store;
                dispatch("recipes/cloneRecipe", { "id": this.recipeData.id, "lang": lang })
                    .then(response => {
                    if(this.$store.state.recipes.update.error){
                        swal.fire({
                        title: `An error has occurred. Please try again.`,
                        text: '',
                        type: 'warning',
                        showCancelButton: false,
                        confirmButtonClass: 'btn btn-success btn-fill',
                        confirmButtonText: 'Close',
                        buttonsStyling: false,
                        });
                        console.log('Something went wrong: recipe clone ', error);
                    }else{
                        swal.fire({
                        title: `Recipe has been created.`,
                        text: '',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonClass: 'btn btn-success btn-fill',
                        cancelButtonClass: 'btn btn-danger btn-fill',
                        confirmButtonText: 'Edit Recipe',
                        cancelButtonText: 'Ok',
                        buttonsStyling: false,
                        }).then((result) => {
                        if (result.value) {
                            //this.$router.push({path: `/recipe/edit-recipe/${this.$store.state.recipes.clone.id}?lang=${lang}`});    
                            this.$router.push({path: `/recipe/edit-recipe/${this.$store.state.recipes.clone.id}`});    
                        }
                        });
                    }
                }).catch(error => {
                    console.log('Something went wrong: ', error);
                });
            }
            });
        },
        dateFormat(date) {
            const serverTime = addHours(new Date(), 5)
            const recipeDate = distanceInWords(date,serverTime)
            return `${recipeDate} ago`
        },
        initFlickity() {
            const articleSlider = document.querySelector(".js-slider");
            if (articleSlider) {
                const flky = new Flickity(articleSlider, {
                    prevNextButtons: false,
                    wrapAround: true,
                });
            }
        },
        async handleFavorite(recipe) {
            if (this.userRecipeData.hasFavorited) {
                this.userRecipeData.hasFavorited = false;
            } else {
                this.userRecipeData.hasFavorited = true;
            }

            try {
                const response = await apiClient(`recipes/${recipe}/favorite`).get();
            } catch (error) {
                console.log(error);
            }

            
        },
        async handleLike(event, recipe) {
            event.preventDefault();

            if (this.userRecipeData.hasLiked) {
                this.userRecipeData.hasLiked = false;
                this.$store.state.recipes.current.likes--
            } else {
                this.userRecipeData.hasLiked = true;
                this.$store.state.recipes.current.likes++
            }

            try {
                const response = await apiClient(`recipes/${recipe}/like`).get();
            } catch (error) {
                console.log(error);
            }

            
        },
        print() 
        {
            swal.fire({
                title: 'Generating PDF',
                text: `Your pdf is being created. One moment please.`,
                type: 'warning',
                allowOutsideClick: false,
                onBeforeOpen: () => {
                    swal.showLoading()
                },
            });

            axios({
                url: `${process.env.VUE_APP_API_HOSTNAME}/api/recipes/${this.$store.state.recipes.current.id}/pdf`,
                method: 'GET',
                responseType: 'blob',
                withCredentials: false,
                headers: authHeader()
            }).then((response) => {
                 var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                 var fileLink = document.createElement('a');

                 fileLink.href = fileURL;
                 fileLink.setAttribute('download', `${this.$store.state.recipes.current.name.toLowerCase().replace(/\s/g , "-").replace(/[^a-z0-9-]/gi,'')}-recipe.pdf`);
                 document.body.appendChild(fileLink);

                 fileLink.click();
            }).then((response)=>{
                swal.close();
            });

            //window.open(this.$store.state.recipes.current.pdfFile.absoluteUri, '_blank');
        },
        printPPT() 
        {
            swal.fire({
                title: 'Generating PPT',
                text: `Your ppt is being created. One moment please.`,
                type: 'warning',
                allowOutsideClick: false,
                onBeforeOpen: () => {
                    swal.showLoading()
                },
            });

            axios({
                url: `${process.env.VUE_APP_API_HOSTNAME}/api/recipes/${this.$store.state.recipes.current.id}/ppt`,
                method: 'GET',
                responseType: 'blob',
                withCredentials: false,
                headers: authHeader()
            }).then((response) => {
                 var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                 var fileLink = document.createElement('a');

                 fileLink.href = fileURL;
                 fileLink.setAttribute('download', `${this.$store.state.recipes.current.name.toLowerCase().replace(/\s/g , "-").replace(/[^a-z0-9-]/gi,'')}-recipe.pptx`);
                 document.body.appendChild(fileLink);

                 fileLink.click();
            }).then((response)=>{
                swal.close();
            });

            //window.open(this.$store.state.recipes.current.pdfFile.absoluteUri, '_blank');
        },
        onCreated() {
            const { dispatch } = this.$store;
            var payload = {
                "page": 1,
                "pageSize": 1000,
                "query": ''
            }
            dispatch("users/getAll", payload);
            dispatch('collections/getAllCollections');
        },
        async handleShare() {
            await swal.fire({
                title: 'Share',
                input: 'select',
                text: `Select the user you would like to share with.`,
                showCancelButton: true,
                inputOptions: this.userList,
                inputPlaceholder: 'Select a user',
                inputValidator: (value) => {
                    return new Promise((resolve) => {
                    if (value) {
                        resolve()
                    } else {
                        resolve('Please select a user')
                    }
                    })
                }
            }).then((result) => {
                if (result.value) {
                 this.submitShare(result.value);
                }
            });
        },
        async submitShare(userId) {
            const { dispatch } = this.$store;
            if (userId) {
                await dispatch("notifications/recipeShare", { "recipeId": this.recipeData.id, "receiverId": userId })
                this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Request sent'});
            }
        },
        async handleAddToCollection() {
            if ( Object.keys(this.collectionList).length > 0 ) {
                await swal.fire({
                title: 'Add To Collection',
                input: 'select',
                text: `Select the collection.`,
                showCancelButton: true,
                inputOptions: this.collectionList,
                inputPlaceholder: 'Select a collection',
                inputValidator: (value) => {
                    return new Promise((resolve) => {
                    if (value) {
                        resolve()
                    } else {
                        resolve('Please select a collection')
                    }
                    })
                }
            }).then((result) => {
                if (result.value) {
                 this.submitAddToCollection(result.value);
                }
            });
            }
            
        },
        async submitAddToCollection(collectionId) {
            const { dispatch } = this.$store;
            if (collectionId) {
                var recipePayload = {
                    'id': this.recipeData.id,
                    'isActive': true,
                    'isVisible': true
                }
                var payload = {
                    'collectionId': collectionId,
                    'recipe': recipePayload
                }
                await dispatch("collections/addRecipeToCollection", payload).then(response => {
                    this.refreshRecipeData();
                    this.$notify({verticalAlign: 'top', horizontalAlign: 'right', type: 'success', message: 'Added to collection'});
                });
                // TODO: Add collection object to recipeCollections
            }
        },
        async refreshRecipeData() {
            const { dispatch } = this.$store;
            await dispatch("recipes/getById", this.recipeData.id).then(response => {
                this.refreshCollectionList();
            })
        },
        isInCollection(collectionId ) {
            for ( const property in this.recipeData.recipeCollections ) {
                if ( collectionId == this.recipeData.recipeCollections[property].id ) {
                    return true
                }
            }
            return false
        },
        refreshCollectionList() {
            this.collectionList = {}
            for (const property in this.collections) {
                if ( this.recipeData.recipeCollections && Object.keys(this.recipeData.recipeCollections).length > 0 ) {
                    let findCollection = this.recipeData.recipeCollections.find(item => item.collection.id === this.collections[property].id);
                    if ( !findCollection ) {
                        this.addToCollections = true;
                        this.collectionList[this.collections[property].id] = this.collections[property].title
                    }
                } else {
                    this.addToCollections = true;
                    this.collectionList[this.collections[property].id] = this.collections[property].title;
                }
            }
            if ( Object.keys(this.collectionList).length < 1 ) {
                this.addToCollections = false
            }
        },
        closeModal() {
        //alert(this.email);
        }
    },
    created() {
        this.onCreated();
    },
    mounted() {
        
    },
    updated: function () {
        this.$nextTick(function () {
            this.refreshCollectionList()
        })
    },
    watch: {
        $route(to, from) {
            this.onCreated();
        },
        isLoading (newLoad, oldLoad) {
        },
        users (val) {
            for (const property in this.users) {
                if ( this.users[property].firstName ) {
                    this.userList[this.users[property].id] = this.users[property].fullNameLastFirst
                }
            }
        },
        recipeSlides (to, from) {
            setTimeout(() => {
                  this.initFlickity();
                  }, 800);
        },
        collections (val) {
            this.refreshCollectionList();
        }
    },
};
</script>

<style>
.jobCodeOperator {
    margin: 15px 0 0 3px;
    font-size: 13px;
    line-height: 1.38;
    color: #8898AA;
    font-weight: normal;
}
.operatorName {
    margin-left: 10px;
}
.statusName, .original-file {
    float:right;
    margin: -20px 0 0 10px;
}
.brand-name {
    margin: 0 5px 0 0
}
</style>
